import { Row, Col, FormGroup, Modal } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Select from '../../components/Select';
import DateInput from '../../components/DateInput';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import AnalisadorSimuladorController from '../../controllers/Empresa/AnalisadorSimuladorController';
import { updateState, dateToString, numberToString, formatDate, downloadBase64File } from '../../utils/Functions';
import SubCadastro from '../../components/SubCadastro';
import Document from '../../components/Document';
import { Filler } from '../../components/Filler';
import DecimalInput from '../../components/DecimalInput';
import Button from '../../components/Button';
import { getParametrosParaCadastroDeCertificado } from '../../utils/ParametrosParaCadastroDeCertificado';
import { faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import SessionManager from './../../models/SessionManager';
import IconButton from '../../components/IconButton';
import Line from '../../components/Line';
import { showError } from '../../components/Messages';
import { LayoutParams } from './../../config/LayoutParams';
import ListaPadrao from './../ListaPadrao';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

let LANG = {};

export default class AnalisadorSimuladorView extends Component {
   constructor(props) {
      super(props);
      this.state = { mostrarAcessos: true, mostrarPlanilha: true, mostrarTendencia: true, firmwareState: {}, anexoState: {}, itemSelecionado: null, aceitouTermos: false, };
      this.controller = new AnalisadorSimuladorController(this);
      LANG = this.props.lang;
      this.lang = this.props.lang;
      let sessionManager = new SessionManager();
      this.login = sessionManager.getLogin();
   }

   getParameterTypeDesc = (parameterType) => {
      let itens = getParametrosParaCadastroDeCertificado(this.state.itemSelecionado);
      let item = itens.filter((i) => i.id === parameterType)[0];
      return item.descricao;
   };

   componentDidUpdate(prevProps, prevState) {
      if (prevState.itemSelecionado !== this.state.itemSelecionado) {
         this.setState({ aceitouTermos: false });
      }
   }

   renderizarFormulario = () => {
      let lang = this.props.lang;
      let telaDeCadastroDeAnalisadorSimulador = lang.telaDeCadastroDeAnalisadorSimulador;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2}>
                  <FormGroup>
                     <Label>{LANG.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.tipoDeEquipamento}</Label>
                     <TextInput
                        readOnly
                        defaultValue={
                           this.state.itemSelecionado.tipoDeEquipamento
                              ? this.state.itemSelecionado.tipoDeEquipamento.nome
                              : null
                        }
                     />
                  </FormGroup>
               </Col>

               <Col sm={3} md={3} lg={3}>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.situacao}</Label>
                     <Select
                        name="situacaoNaEmpresa"
                        defaultValue={
                           this.state.itemSelecionado.situacaoNaEmpresa &&
                           this.state.itemSelecionado.situacaoNaEmpresa.id
                        }
                        options={[
                           { id: 1, descricao: lang.telaDeCadastroDeAnalisadorSimulador.ativo },
                           { id: 2, descricao: lang.telaDeCadastroDeAnalisadorSimulador.inativo },
                        ]}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.situacaoNaEmpresa = i;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>
            <Row>
               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.numeroDeSerie}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.numeroDeSerie} />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.dataDeFabricacao}</Label>
                     <TextInput
                        readOnly
                        defaultValue={dateToString(this.state.itemSelecionado.dataDeFabricacao, this.props.lang)}
                     />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.tipoDeConta}</Label>
                     <TextInput
                        readOnly
                        defaultValue={
                           this.state.itemSelecionado.tipoDeConta ? this.state.itemSelecionado.tipoDeConta.nome : null
                        }
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.numeroDePatrimonio}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.numeroDePatrimonio}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.numeroDePatrimonio = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>

               <Col sm={3} xs={3} md={3}>
                  <Label>{telaDeCadastroDeAnalisadorSimulador.dataDeCalibracao}</Label>
                  <DateInput
                     defaultValue={this.state.itemSelecionado.dataDeCalibracao}
                     onChange={(value) => {
                        updateState(this, (state) => {
                           state.itemSelecionado.dataDeCalibracao = value;
                        });
                     }}
                  />
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.tempoDeDuracaoDaCalibracao}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.tempoDeDuracaoDaCalibracao}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.tempoDeDuracaoDaCalibracao = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>

               <Col>
                  <FormGroup>
                     <Label>{telaDeCadastroDeAnalisadorSimulador.numeroDoCertificadoVigente}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.numeroDoCertificado}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.numeroDoCertificado = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col>
                  <FormGroup>
                     <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.calibradoPor}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.calibradoPor}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.calibradoPor = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
            </Row>

            {this.certificados()}


            <Filler height={10} />
         </React.Fragment>
      );
   };

   certificados = () => {
      return (
         <Row
            style={{
               lineHeight: 1,
            }}
         >
            <Col>
               <FormGroup>
                  <SubCadastro
                     titulo={this.lang.telaDeCadastroDeAnalisadorSimulador.certificadosDeCalibracao}
                     exibirTitulos={true}
                     itens={this.state.itemSelecionado.certificadosDeCalibracao}
                     lang={this.lang}
                     modal={true}
                     tableStyle={{ backgroundColor: 'white' }}
                     formStyle={{ backgroundColor: 'white' }}
                     novo={() => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.certificadoDeCalibracaoSelecionado = {
                                 certificadoDeCalibracao: {
                                    situacao: { id: 1 },
                                 },
                              };
                           }).then(resolve);
                        });
                     }}
                     cancelar={() => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.certificadoDeCalibracaoSelecionado = null;
                           }).then(resolve);
                        });
                     }}
                     inserir={this.controller.inserirCertificadoDeCalibracao}
                     selecionarParaAlteracao={(index) => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.certificadoDeCalibracaoSelecionado = JSON.parse(
                                 JSON.stringify(state.itemSelecionado.certificadosDeCalibracao[index])
                              );
                           }).then(() => resolve());
                        });
                     }}
                     alterar={this.controller.alterarCertificadoDeCalibracao}
                     excluir={(index) => {
                        updateState(this, (state) => {
                           state.itemSelecionado.certificadosDeCalibracao.splice(index, 1);
                        });
                     }}
                     colunas={() => {
                        return [
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.numeroDoCertificado,
                              width: '20%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.arquivo,
                              width: '40%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.dataDeValidade,
                              width: '20%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.situacao,
                              width: '20%',
                              className: null,
                           },
                        ];
                     }}
                     linha={(item) => {
                        return [
                           item.certificadoDeCalibracao.numeroDoCertificado,
                           item.certificadoDeCalibracao && item.certificadoDeCalibracao.arquivo
                              ? item.certificadoDeCalibracao.arquivo.descricao
                              : null,
                           dateToString(item.certificadoDeCalibracao.dataDeValidade, this.props.lang),
                           this.controller.getDescricaoDaSituacaoDoCertificado(
                              item.certificadoDeCalibracao.dataDeValidade
                           ),
                        ];
                     }}
                     formulario={() => {
                        return (
                           <div>
                              <Row>
                                 <Col sm={9} xs={9} md={9}>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.arquivo}</Label>
                                       <Document
                                          lang={this.props.lang}
                                          api={this.props.api}
                                          maxSize={1 * 1024 * 1024}
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado &&
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao &&
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .arquivo
                                          }
                                          onChange={(file) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.arquivo =
                                                   file;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col sm={3} xs={3} md={3}>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.dataDeValidade}</Label>
                                       <DateInput
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .dataDeValidade
                                          }
                                          onChange={(value) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.dataDeValidade =
                                                   value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>

                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.calibradoPor}</Label>
                                       <TextInput
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .calibradoPor
                                          }
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.calibradoPor =
                                                   e.target.value;
                                             });
                                          }}
                                          upperCase={true}
                                       />
                                    </FormGroup>
                                 </Col>

                                 <Col sm={3} xs={3} md={3}>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.dataDeCalibracao}</Label>
                                       <DateInput
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .dataDaCalibracao
                                          }
                                          onChange={(value) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.dataDaCalibracao =
                                                   value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.localDaCalibracao}</Label>
                                       <TextInput
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .localDaCalibracao
                                          }
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.localDaCalibracao =
                                                   e.target.value;
                                             });
                                          }}
                                          upperCase={true}
                                       />
                                    </FormGroup>
                                 </Col>
                                 <Col sm={3} xs={3} md={3}>
                                    <FormGroup>
                                       <Label>
                                          {this.lang.telaDeCadastroDeAnalisadorSimulador.numeroDoCertificado}
                                       </Label>
                                       <TextInput
                                          defaultValue={
                                             this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                .numeroDoCertificado
                                          }
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.numeroDoCertificado =
                                                   e.target.value;
                                             });
                                          }}
                                          upperCase={true}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>

                              <Row>
                                 {this.state.mostrarPlanilha && (
                                    <Col>
                                       <FormGroup>
                                          <Label>
                                             {
                                                this.lang.telaDeCadastroDeAnalisadorSimulador
                                                   .importarResultadosDePlanilha
                                             }
                                             &nbsp;&nbsp;
                                             <IconButton
                                                style={{ fontSize: 20, color: 'green' }}
                                                cursor="pointer"
                                                icon={faFileExcel}
                                                title={
                                                   this.lang.telaDeCadastroDeAnalisadorSimulador.baixarPlanilhaModelo
                                                }
                                                onClick={() => {
                                                   var sigla = this.state.itemSelecionado.tipoDeEquipamento.sigla;
                                                   let idioma = this.login.idioma ? this.login.idioma : 'pt-BR';
                                                   let a = document.createElement('a');
                                                   a.download = sigla;
                                                   a.href =
                                                      this.props.api.urlBase() +
                                                      '/publicfile/download/' +
                                                      sigla +
                                                      '_' +
                                                      idioma +
                                                      '.xlsx';
                                                   document.body.appendChild(a);
                                                   a.click();
                                                   document.body.removeChild(a);
                                                }}
                                             />
                                          </Label>
                                          <Document
                                             lang={this.props.lang}
                                             api={this.props.api}
                                             accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                             defaultValue={
                                                this.state.certificadoDeCalibracaoSelecionado &&
                                                this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao &&
                                                this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao
                                                   .planilha
                                             }
                                             onChange={(file) => {
                                                updateState(this, (state) => {
                                                   state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.planilha =
                                                      file;
                                                });
                                             }}
                                          />
                                       </FormGroup>
                                    </Col>
                                 )}
                                 {this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.planilha && (
                                    <Col md={2} lg={2} xl={2}>
                                       <FormGroup>
                                          <Label>&nbsp;</Label>
                                          <Button
                                             onClick={this.controller.importarResultados}
                                             text={this.props.lang.telaDeCadastroDeAnalisadorSimulador.importar}
                                          />
                                       </FormGroup>
                                    </Col>
                                 )}
                              </Row>

                              {this.resultados()}

                              <br />
                           </div>
                        );
                     }}
                  />
               </FormGroup>
            </Col>
         </Row>
      );
   };

   resultados = () => {
      return (
         <Row>
            <Col>
               <FormGroup>
                  <SubCadastro
                     titulo={this.lang.telaDeCadastroDeAnalisadorSimulador.resultadosDoCertificadosDeCalibracao}
                     exibirTitulos={true}
                     itens={this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.resultados}
                     lang={this.lang}
                     novo={() => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.resultadoSelecionado = {};
                           }).then(resolve);
                        });
                     }}
                     cancelar={() => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.resultadoSelecionado = null;
                           }).then(resolve);
                        });
                     }}
                     inserir={this.controller.inserirResultadoDeCertificadoDeCalibracao}
                     selecionarParaAlteracao={(index) => {
                        return new Promise((resolve) => {
                           updateState(this, (state) => {
                              state.resultadoSelecionado = JSON.parse(
                                 JSON.stringify(
                                    this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.resultados[
                                       index
                                    ]
                                 )
                              );
                           }).then(() => resolve());
                        });
                     }}
                     alterar={this.controller.alterarResultadoDeCertificadoDeCalibracao}
                     excluir={(index) => {
                        updateState(this, (state) => {
                           this.state.certificadoDeCalibracaoSelecionado.certificadoDeCalibracao.resultados.splice(
                              index,
                              1
                           );
                        });
                     }}
                     colunas={() => {
                        return [
                           {
                              titulo: this.lang.codigo,
                              width: '10%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.parametro,
                              width: '20%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.valorDeReferencia,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.valorMedido,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.tendencia,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.tendenciaPercentual,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.incerteza,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.fatorDeAbrangencia,
                              width: '15%',
                              className: null,
                           },
                           {
                              titulo: this.lang.telaDeCadastroDeAnalisadorSimulador.grauDeLiberdade,
                              width: '15%',
                              className: null,
                           },
                        ];
                     }}
                     linha={(item) => {
                        return [
                           item.id > 0 ? item.id : null,
                           this.getParameterTypeDesc(item.parameterType),
                           numberToString(item.referenceValue, 0, 6, this.lang),
                           numberToString(item.measuredValue, 0, 6, this.lang),
                           numberToString(item.tendency, 0, 6, this.lang),
                           numberToString(item.percentTendency, 0, 6, this.lang),
                           numberToString(item.uncertainty, 0, 6, this.lang),
                           numberToString(item.coverageFactor, 0, 6, this.lang),
                           numberToString(item.degreesOfFreedom, 0, 6, this.lang),
                        ];
                     }}
                     formulario={() => {
                        const usarSegundoParametro =
                           this.state.configuracaoDeParametros && this.state.configuracaoDeParametros.length >= 2;
                        const usarTerceiroParametro =
                           this.state.configuracaoDeParametros && this.state.configuracaoDeParametros.length >= 3;
                        return (
                           <div
                              style={{
                                 fontSize: 13,
                              }}
                           >
                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.parametro}</Label>
                                       <Select
                                          defaultValue={this.state.resultadoSelecionado.parameterType}
                                          options={getParametrosParaCadastroDeCertificado(this.state.itemSelecionado)}
                                          getKeyValue={(i) => i.id}
                                          getDescription={(i) => i.descricao}
                                          allowEmpty={false}
                                          acceptZero={true}
                                          onSelect={(i) => {
                                             updateState(this, (state) => {
                                                if (i != null) {
                                                   state.resultadoSelecionado.parameterType = i.id;
                                                   state.resultadoSelecionado.parameterTypeDesc = i.descricao;
                                                   state.configuracaoDeParametros = i.parametros;
                                                } else {
                                                   state.resultadoSelecionado.parameterType = 0;
                                                   state.resultadoSelecionado.parameterTypeDesc = null;
                                                   state.configuracaoDeParametros = null;
                                                }
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>

                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.grauDeLiberdade}</Label>
                                       <DecimalInput
                                          lang={this.lang}
                                          defaultValue={this.state.resultadoSelecionado.degreesOfFreedom}
                                          decimalPlaces={0}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.resultadoSelecionado.degreesOfFreedom = e.value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.valorDeReferencia}</Label>
                                       <DecimalInput
                                          lang={this.lang}
                                          defaultValue={this.state.resultadoSelecionado.referenceValue}
                                          decimalPlaces={0}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.resultadoSelecionado.referenceValue = e.value;
                                                this.calcularTendencia(state);
                                             }).then(() => {
                                                updateState(this, (state) => {
                                                   state.mostrarTendencia = true;
                                                });
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>

                                 {usarSegundoParametro && (
                                    <Col>
                                       <FormGroup>
                                          <Label>{this.state.configuracaoDeParametros[1]}</Label>
                                          <DecimalInput
                                             lang={this.lang}
                                             defaultValue={this.state.resultadoSelecionado.referenceValue2}
                                             decimalPlaces={0}
                                             onChange={(e) => {
                                                updateState(this, (state) => {
                                                   state.resultadoSelecionado.referenceValue2 = e.value;
                                                });
                                             }}
                                          />
                                       </FormGroup>
                                    </Col>
                                 )}

                                 {usarTerceiroParametro && (
                                    <Col>
                                       <FormGroup>
                                          <Label>{this.state.configuracaoDeParametros[2]}</Label>
                                          <DecimalInput
                                             lang={this.lang}
                                             defaultValue={this.state.resultadoSelecionado.referenceValue3}
                                             decimalPlaces={0}
                                             onChange={(e) => {
                                                updateState(this, (state) => {
                                                   state.resultadoSelecionado.referenceValue3 = e.value;
                                                });
                                             }}
                                          />
                                       </FormGroup>
                                    </Col>
                                 )}

                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.valorMedido}</Label>
                                       <DecimalInput
                                          lang={this.lang}
                                          defaultValue={this.state.resultadoSelecionado.measuredValue}
                                          decimalPlaces={0}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.resultadoSelecionado.measuredValue = e.value;
                                                this.calcularTendencia(state);
                                             }).then(() => {
                                                updateState(this, (state) => {
                                                   state.mostrarTendencia = true;
                                                });
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.tendencia}</Label>
                                       {this.state.mostrarTendencia && (
                                          <DecimalInput
                                             lang={this.lang}
                                             defaultValue={this.state.resultadoSelecionado.tendency}
                                             decimalPlaces={0}
                                             onChange={(e) => {
                                                updateState(this, (state) => {
                                                   state.resultadoSelecionado.tendency = e.value;
                                                });
                                             }}
                                          />
                                       )}
                                    </FormGroup>
                                 </Col>

                                 <Col>
                                    <FormGroup>
                                       <Label>
                                          {this.lang.telaDeCadastroDeAnalisadorSimulador.tendenciaPercentual}
                                       </Label>
                                       {this.state.mostrarTendencia && (
                                          <DecimalInput
                                             lang={this.lang}
                                             defaultValue={this.state.resultadoSelecionado.percentTendency}
                                             decimalPlaces={0}
                                             onChange={(e) => {
                                                updateState(this, (state) => {
                                                   state.resultadoSelecionado.percentTendency = e.value;
                                                });
                                             }}
                                          />
                                       )}
                                    </FormGroup>
                                 </Col>
                              </Row>
                              <Row>
                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.incerteza}</Label>
                                       <DecimalInput
                                          lang={this.lang}
                                          defaultValue={this.state.resultadoSelecionado.uncertainty}
                                          decimalPlaces={0}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.resultadoSelecionado.uncertainty = e.value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>

                                 <Col>
                                    <FormGroup>
                                       <Label>{this.lang.telaDeCadastroDeAnalisadorSimulador.fatorDeAbrangencia}</Label>
                                       <DecimalInput
                                          lang={this.lang}
                                          defaultValue={this.state.resultadoSelecionado.coverageFactor}
                                          decimalPlaces={0}
                                          onChange={(e) => {
                                             updateState(this, (state) => {
                                                state.resultadoSelecionado.coverageFactor = e.value;
                                             });
                                          }}
                                       />
                                    </FormGroup>
                                 </Col>
                              </Row>
                           </div>
                        );
                     }}
                  />
               </FormGroup>
            </Col>
         </Row>
      );
   };

   baixarArquivoDeFirmware = (item) => {
      this.props.api
         .get('/file/base64/' + item.nome)
         .then((data) => {
            downloadBase64File(data, item.descricao ? item.descricao : item.nome, item.tipo);
         })
         .catch((e) => {});
   };

   baixarAnexo = (item) => {
   if (!item || !item.anexo || !item.anexo.nome) {
      showError(this.lang.telaDeCadastroDeAnalisadorSimulador.mensagens.anexoNaoDisponivel);
      return;
   }

   this.props.api
      .get('/file/base64/' + item.anexo.nome)
      .then((data) => {
         downloadBase64File(data, item.descricao ? item.descricao : item.anexo.nome, item.anexo.tipo);
      })
      .catch((e) => {
         console.error("Erro ao baixar anexo:", e);
         showError("Erro ao baixar anexo.");
      });
   };

   calcularTendencia = (state) => {
      try {
         state.resultadoSelecionado.tendency = parseFloat(
            Math.abs(state.resultadoSelecionado.referenceValue - state.resultadoSelecionado.measuredValue).toFixed(6)
         );
         state.resultadoSelecionado.percentTendency = parseFloat(
            ((state.resultadoSelecionado.tendency * 100) / state.resultadoSelecionado.referenceValue).toFixed(6)
         );
      } catch (e) {}
      state.mostrarTendencia = false;
   };

   getFiltro = (filtro) => {
      var result = this.props.filtroExtra ? this.props.filtroExtra() : {};
      result.dataDeValidadeDoCertificadoInicial = this.state.dataDeValidadeDoCertificadoInicial
         ? formatDate(this.state.dataDeValidadeDoCertificadoInicial)
         : null;
      result.dataDeValidadeDoCertificadoFinal = this.state.dataDeValidadeDoCertificadoFinal
         ? formatDate(this.state.dataDeValidadeDoCertificadoFinal)
         : null;
      result.numeroDeSerie = this.state.numeroDeSerie ? this.state.numeroDeSerie : null;
      result.numeroDePatrimonio = this.state.numeroDePatrimonio ? this.state.numeroDePatrimonio : null;
      result.sigla = this.state.sigla ? this.state.sigla : null;
      return result;
   };

   renderizarFiltros = (sender) => {
      return (
         <div>
            <Row>
               <Col>
                  <FormGroup>
                     <Label>{LANG.telaDeCadastroDeAnalisadorSimulador.tipo}</Label>
                     <TextInput upperCase={true} onChange={(e) => this.setState({ sigla: e.target.value })} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{LANG.telaDeCadastroDeAnalisadorSimulador.numeroDeSerie}</Label>
                     <TextInput onChange={(e) => this.setState({ numeroDeSerie: e.target.value })} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{LANG.telaDeCadastroDeAnalisadorSimulador.numeroDePatrimonio}</Label>
                     <TextInput onChange={(e) => this.setState({ numeroDePatrimonio: e.target.value })} />
                  </FormGroup>
               </Col>

               <Col style={{ maxWidth: 250 }}>
                  <FormGroup>
                     <Label>{LANG.telaDeCadastroDeAnalisadorSimulador.dataDeValidadeInicial}</Label>
                     <DateInput
                        onChange={(value) => {
                           updateState(this, (state) => {
                              state.dataDeValidadeDoCertificadoInicial = value;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
               <Col style={{ maxWidth: 250 }}>
                  <FormGroup>
                     <Label>{LANG.telaDeCadastroDeAnalisadorSimulador.dataDeValidadeFinal}</Label>
                     <DateInput
                        onChange={(value) => {
                           updateState(this, (state) => {
                              state.dataDeValidadeDoCertificadoFinal = value;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <Row>
               <Col>
                  <Button
                     onClickAsync={sender.filtrar}
                     text={this.props.lang.pesquisar}
                     inProgressText={this.props.lang.pesquisando}
                     style={{ width: 200 }}
                  />
                  <br />
               </Col>
            </Row>
         </div>
      );
   };

   getTitulosDaTabelaDeFirmwares = () => {
      let telaDeCadastroDeAnalisadorSimulador = this.lang.telaDeCadastroDeAnalisadorSimulador;
      return [
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.firmwares.numeroDaVersao,
            width: '17%',
            className: null,
         },
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.firmwares.dataDeLiberacao,
            width: '15%',
            className: null,
         },
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.firmwares.descricaoDasAlteracoes,
            width: '30%',
            className: null,
         },
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.firmwares.arquivoDeFirmware,
            width: '28%',
            className: null,
         },
         {
            titulo: 'Download',
            width: '10%',
            className: null,
         },
      ];
   };

   getDadosDaTabelaDeFirmwares = (item) => {
      let telaDeCadastroDeAnalisadorSimulador = this.lang.telaDeCadastroDeAnalisadorSimulador;
      return [
         item.numeroDaVersao,
         dateToString(item.dataDeLiberacao, this.props.lang),
         item.descricaoDasAlteracoes,
         item.arquivoDeFirmware ? item.arquivoDeFirmware.descricao : null,
         <div style={{ width: '100%', paddingTop: 2, textAlign: 'center' }}>
            <IconButton
               title={telaDeCadastroDeAnalisadorSimulador.firmwares.baixarZip}
               style={{
                  fontSize: 16,
                  color: '#666',
               }}
               icon={faDownload}
               onClick={() => this.baixarArquivoDeFirmware(item.arquivoDeFirmware)}
            />
         </div>,
      ];
   };

   getTitulosDaTabelaDeAnexos = () => {
      let telaDeCadastroDeAnalisadorSimulador = this.lang.telaDeCadastroDeAnalisadorSimulador;
      return [
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.anexos.descricao,
            width: '40%',
            className: null,
         },
         {
            titulo: telaDeCadastroDeAnalisadorSimulador.anexos.anexo,
            width: '50%',
            className: null,
         },
         {
            titulo: 'Download',
            width: '10%',
            className: null,
         },
      ];
   };

   getDadosDaTabelaDeAnexos = (item) => {
      let telaDeCadastroDeAnalisadorSimulador = this.lang.telaDeCadastroDeAnalisadorSimulador;
      return [
         item.descricao,
         item.anexo ? item.anexo.descricao : null,
         <div style={{ width: '100%', paddingTop: 2, textAlign: 'center' }}>
            <IconButton
               title={telaDeCadastroDeAnalisadorSimulador.anexos.baixarArquivo}
               style={{
                  fontSize: 16,
                  color: '#666',
               }}
               icon={faDownload}
               onClick={() => this.baixarAnexo(item.anexo)}
            />
         </div>,
      ];
   };

   mostrarErroTermos = () => {
      const msg =
         this.lang.telaDeCadastroDeAnalisadorSimulador.mensagens.aceiteTermosObrigatorio;

      if (this.props?.api?.toast?.error) return this.props.api.toast.error(msg);
      if (this.props?.toast?.error) return this.props.toast.error(msg);

      window.alert(msg);
      };

      garantirTermosAntesDe = (acao) => {
      if (!this.state.aceitouTermos) {
         this.mostrarErroTermos();
         return;
      }
      acao();
   };

   renderizarAcoesDoFormulario = () => {
      let firmwareMaisRecente = this.state.itemSelecionado.firmwareMaisRecente;
      let listaDeFirmwares = this.state.itemSelecionado.tipoDeEquipamento.firmwares;
      let listaDeAnexos = this.state.itemSelecionado.tipoDeEquipamento.anexos;
      
      return (
         <div>
            <span>{this.lang.telaDeCadastroDeAnalisadorSimulador.anexos}</span>
            <Line marginBottom={1} />

         <Row>
            <Col>
               {listaDeAnexos.length === 0 && <span>vazio</span>}

               {listaDeAnexos.map((anexo, idx) => (
                  <div
                     key={idx}
                     style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "6px 0",
                        borderBottom: "1px solid #eee"
                     }}
                  >
                     <span>{anexo.descricao}</span>
                     <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ fontSize: 14 }}>{anexo.anexo?.descricao}</span>
                        <IconButton
                           style={{ fontSize: 16, color: "#666" }}
                           cursor="pointer"
                           icon={faDownload}
                           title={this.lang.telaDeCadastroDeAnalisadorSimulador.anexos.baixarArquivo}
                           onClick={() => this.baixarAnexo(anexo)}
                        />
                     </div>
                  </div>
               ))}
            </Col>
         </Row>

         <br />

         <Row>
            {(firmwareMaisRecente || listaDeFirmwares.length > 0) && (
               <Col>
                  <span>{this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.titulo}</span>
                  <Line marginBottom={5} />
               </Col>
            )}
         </Row>

         {firmwareMaisRecente && (
         <>
            {/* ALERTA */}
            <Row>
               <Col>
               <div
                  style={{
                     marginTop: 10,
                     marginBottom: 10,
                     fontSize: 13,
                     fontWeight: 'bold',
                  }}
               >
                  {this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.alerta}
               </div>
               </Col>
            </Row>

            {/* CHECKBOX */}
            <Row style={{ marginLeft: 0 }}>
               <label
               style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  fontWeight: 'bold',
               }}
               >
               <input
                  type="checkbox"
                  checked={this.state.aceitouTermos}
                  onChange={(e) =>
                     this.setState({ aceitouTermos: e.target.checked })
                  }
               />
               {this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.liEConcordo}
               </label>
            </Row>

            {/* BOTÕES */}
            <Row style={{ marginTop: 12 }}>
               <Button
               style={{ width: 210, marginLeft: 14 }}
               text={`${this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.baixarVersao} 
                  ${this.state.itemSelecionado.firmwareMaisRecente.numeroDaVersao}`}
               disabled={false}
               onClick={() =>
                  this.garantirTermosAntesDe(() =>
                     this.baixarArquivoDeFirmware(firmwareMaisRecente.arquivoDeFirmware)
                  )
               }
               />

               {listaDeFirmwares && listaDeFirmwares.length >= 1 && (
               <Button
                  style={{ width: 200 }}
                  text={this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.outrasVersoes}
                  disabled={false}
                  onClick={() =>
                     this.garantirTermosAntesDe(() =>
                     this.setState({ mostrarVersoesAntigas: true })
                     )
                  }
               />
               )}
            </Row>

            {/* INSTRUÇÕES */}
            <Row>
               <Col>
               <div
                  style={{
                     padding: 12,
                     borderRadius: 8,
                     border: '1px solid #e0e0e0',
                     background: '#fafafa',
                     marginTop: 16,
                     marginBottom: 30,
                     fontSize: 13,
                  }}
               >
                  <div style={{ fontWeight: 600, marginBottom: 6 }}>
                     {this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.instrucoesTitulo}
                  </div>

                  <ol style={{ margin: 0, paddingLeft: 18 }}>
                     <li>{this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.instrucoesPasso1}</li>
                     <li>{this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.instrucoesPasso2}</li>
                     <li>{this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.instrucoesPasso3}</li>
                     <li>{this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.instrucoesPasso4}</li>
                  </ol>
               </div>
               </Col>
            </Row>
         </>
         )}

         <Modal
            show={this.state.mostrarVersoesAntigas}
            scrollable={true}
            onHide={() => {}}
            onKeyDown={(e) => {
               if (e.keyCode === 27) {
                  this.setState({ mostrarVersoesAntigas: false });
               }
            }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            stype={{ padding: 0 }}
         >
            <Modal.Header style={{ backgroundColor: LayoutParams.colors.corDoTemaPrincipal }}>
               <Modal.Title className="h4" style={{ color: LayoutParams.colors.corSecundaria }}>
                  {this.lang.telaDeCadastroDeAnalisadorSimulador.firmwares.titulo}
               </Modal.Title>
            </Modal.Header>

            <Modal.Body
               style={{
                  padding: '0 15px 15px 15px',
                  fontSize: 13,
               }}
            >
               <ListaPadrao
                  titulo={''}
                  esconderTitulo={true}
                  esconderBotaoFechar={true}
                  estruturaPadrao={false}
                  url={'/analisador/firmwares'}
                  api={this.props.api}
                  lang={this.props.lang}
                  getAcoes={() => null}
                  getFiltro={() => {
                     return new Promise((resolve) => {
                        let filtro = {};
                        filtro.idDoAnalisador = this.state.itemSelecionado.id;
                        resolve(filtro);
                     });
                  }}
                  getTitulosDaTabela={this.getTitulosDaTabelaDeFirmwares}
                  getDadosDaTabela={this.getDadosDaTabelaDeFirmwares}
                  getFormState={() => this.state.firmwareState}
                  setFormState={(state, callback) => {
                     return new Promise((resolve) => {
                        this.setState({ firmwareState: state }, () => {
                           resolve();
                           if (callback) {
                              callback();
                           }
                        });
                     });
                  }}
               />
            </Modal.Body>
            <Modal.Footer>
               <div
                  style={{
                     width: '100%',
                     display: 'flex',
                     justifyContent: 'flex-end',
                     padding: '10px 12px 10px 10px',
                  }}
               >
                  <div style={{ width: 150, textAlign: 'left' }}>
                     <Button
                        variant="secondary"
                        onClick={() => {
                           this.setState({ mostrarVersoesAntigas: false });
                        }}
                        style={{ width: 150 }}
                        text={this.props.lang.formularioPadrao.fechar}
                        />
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
      );
   };

   render() {
      return (
         <FormularioPadrao
            titulo={this.props.lang.telaDeCadastroDeAnalisadorSimulador.titulo}
            url={'/analisador'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'numeroDeSerie'}
            permissoes={[1151, 1152, 1153, 1154]}
            getFiltro={this.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            renderizarFiltros={this.renderizarFiltros}
            renderizarAcoesDoFormulario={this.renderizarAcoesDoFormulario}
            getFormState={() => {
               return this.state;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{}}
         />
      );
   }
}
